import React from 'react';
import { useRouteError } from 'react-router-dom';

export default function ErrorPage() {
    const error = useRouteError();
    console.error(error);

    return (
        <div className="min-h-screen flex flex-col justify-center items-center px-4 text-center">
            <h1 className="text-4xl sm:text-5xl font-bold text-red-700 mb-4">
                Oops! Something went wrong.
            </h1>
            <button
                onClick={() => window.history.back()}
                className="bg-red-700 hover:bg-red-800 text-white px-6 py-2 rounded-lg shadow transition duration-300"
            >
                Go Back
            </button>
        </div>
    );
}
